/* eslint-disable @next/next/no-img-element */
import dynamic from "next/dynamic";
import { configuration } from "../../helpers/config";
import { useState } from "react";
import Image from "next/image";
import { ReactImageTurntable } from "react-image-turntable";
import useIsMobile from "../../hooks/useIsMobile";

const ReactPhotoSphereViewer = dynamic(
  () =>
    import("react-photo-sphere-viewer").then(
      (mod) => mod.ReactPhotoSphereViewer,
    ),
  { ssr: false },
);

const InteriorViewer = (props) => {
  const { imageSrc, height } = props;
  const [overlayVisibility, setOverlayVisibility] = useState(true);
  const changeVisibility = () => {
    setTimeout(() => {
      setOverlayVisibility(true);
    }, 3000);
  };
  const mobile = useIsMobile();

  let staticImage = {
    desktop: "",
    mobile: "",
  };

  const idxOfstaticInteriorImage=props.configuratorData && props.configuratorData.hasOwnProperty("variants")?props.configuratorData?.variants[0]?.interior?.interior_images.findIndex(itm=>{
    return itm?.key=="static_image_interiror"
  }):-1;
  if (idxOfstaticInteriorImage > -1) {
    staticImage["desktop"] =
      props.configuratorData?.variants[0]?.interior?.interior_images[
        idxOfstaticInteriorImage
      ]["value"]["desktop"];
    staticImage["mobile"] =
      props.configuratorData?.variants[0]?.interior?.interior_images[
        idxOfstaticInteriorImage
      ]["value"]["mobile"];
  }

  return (
    <>
      {props?.configuratorData?.IntStaticImageToggle ? (
        <ReactImageTurntable
          autoRotate={{ disabled: true }}
          style={{ minHeight: "50vh", height: "100%" }}
          images={[
            `${configuration.IMG_URL}${
              mobile
                ? props?.configuratorData?.staticImgDefault?.interior?.mob_img
                  ? props?.configuratorData?.staticImgDefault?.interior?.mob_img
                  : staticImage["mobile"]
                : props?.configuratorData?.staticImgDefault?.interior?.desk_img
                  ? props?.configuratorData?.staticImgDefault?.interior
                      ?.desk_img
                  : staticImage["desktop"]
            }`,
          ]}
        />
      ) : (
        <div
          className="relative h-[40vh] sm:h-[50vh] md:h-[60vh] lg:h-[80vh]"
          onMouseDown={() => setOverlayVisibility(false)}
          onMouseUp={() => changeVisibility()}
        >
          <ReactPhotoSphereViewer
            defaultZoomLvl={1}
            src={`${imageSrc}?${new Date()}`}
            height={"100%"}
            navbar={false}
            width={"100%"}
            container={""}
          />
          {overlayVisibility && (
            <img
              className="absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] h-[6rem] lg:h-[10rem] w-[6rem] lg:w-[10rem]"
              src={`${configuration.IMG_STATIC_URL}assets/images/360-overlay.svg`}
              alt=""
            />
          )}
        </div>
      )}
    </>
  );
};
export default InteriorViewer;
